<mat-card class="default-card grid-all">
    <mat-card-header>
        <mat-card-title>{{ data.title }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <form class="form-container" #dialogForm="ngForm">
                <mat-form-field>
                    <input matInput data-input-login type="text" placeholder="{{ data.label }}" [(ngModel)]="value" name="inputValue" required autocomplete="false" />
                </mat-form-field>
            </form>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="onDismiss()">Annuler</button>
        <button mat-raised-button class="accent-button" (click)="onConfirm()">Valider</button>
    </mat-card-actions>
</mat-card>
